import React, {Component} from 'react';
import {Api} from '../../api';

import {checkAuth, getAuthToken, getUserId} from '../../utils';
import {DownloadCloudIcon} from '../../components/Common/Icons/Icons'
import {connect} from 'react-redux';
import './TransactionPage.scss';
import TransactionStatus from "../TransactionStatus";
import SelectInput from "../../components/Common/SelectInput";

const ENTITY_TYPES = {
    SENDER: 0,
    RECIPIENT: 1
};

class TransactionPage extends Component {

    state = {
        balance: '',
        query: '',
        entity: '',
        verificationCode: null,
        entities: [
            {
                id: 1,
                title: 'Kyiv, Ukraine'
            }
        ],
        digitalSignature: '',
        digitalSignatures: [
            {
                id: 1,
                title: 'Kyiv, Ukraine'
            }
        ],
        wallet: '',
        wallets: [
            {
                id: 1,
                title: 'Kyiv, Ukraine'
            }
        ],
        transaction: null,
        userId: null,
        credentialSubject: null,
        transactionData: {},
        isLoading: true,
        //We can got this page from  localstorage data or throw api.
        //In first case we declare transaction and no data on back-end api still
        //We get information from previuse page TransactionSelectCompany
        currentUserIsNotDeclarator: {},
        chooseSecondPart: false,
        userCertificateIndex: -1,
        userCompanyIndex: -1,
        userCertificates: [],
        isDataFromLocalStorage: false
    };

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentDidUpdate() {
        if (this.checkAllSigns()) {
            clearInterval(this.interval);
        }
    }

    checkAllSigns = () => {
        const {transactionData} = this.state;
        return transactionData !== null &&
            transactionData.senderDigitalSignature &&
            transactionData.senderDigitalSignature.confirmTime !== null &&
            transactionData.recipientDigitalSignature &&
            transactionData.recipientDigitalSignature.confirmTime !== null &&
            transactionData.cryptoIdSignature &&
            transactionData.cryptoIdSignature.confirmTime !== null &&
            transactionData.cryptoIdSignature &&
            transactionData.cryptoIdSignature.confirmTime !== null;
    };

    componentWillMount() {
        this.props.handleLoader(true);
    }

    componentDidMount() {
        const transactionData = JSON.parse(localStorage.getItem('select-company-transaction'));
        if (transactionData) {
            this.setState({transactionData, isLoading: false, isDataFromLocalStorage: true, userId: getUserId()});
            this.props.handleLoader(false);
        } else {
            const transactionId = this.props.match.params.transactionId;
            if (!transactionId) {
                this.props.history.push('/user/transactions/proof');
            }
            this.getTransaction(() => {
                this.props.handleLoader(false);
                this.interval = setInterval(() => this.getTransaction(), 2000);
            });
        }
    }

    getTransaction = (postTask) => {
        const authToken = getAuthToken();
        let transactionId = this.props.match.params.transactionId;
        if (!transactionId) {
            transactionId = this.state.transactionData.transactionId;
        }
        Api.get(`transaction?id=${transactionId}`, authToken).then((response) => {

            console.log(response, 'get transaction');
            const transactionData = response.data;
            transactionData.paymentDescription = transactionData.description;
            transactionData.senderData = transactionData.senderWallets;
            transactionData.recipientData = transactionData.recipientWallets;
            transactionData.recipientCompany = transactionData.recipientEntity;
            if (transactionData.recipientCompany) {
                transactionData.recipientCompany.entity = transactionData.recipientCompany.name;
            }
            transactionData.senderCompany = transactionData.senderEntity;
            if (transactionData.senderCompany) {
                transactionData.senderCompany.entity = transactionData.senderCompany.name;
            }

            //User status is sender and sender hasn't chosen company and certificate.
            if ((transactionData.userStatus === 'Sender' && !transactionData.senderCompany.userId)
                || transactionData.userStatus === 'Recipient' && !transactionData.recipientCompany.userId) {
                Api.get('certificates/current', authToken).then((response) => {
                    this.setState({
                        userCertificates: response.data,
                        transactionData,
                        chooseSecondPart: true,
                        userId: getUserId(),
                        isLoading: false
                    });
                    if (postTask)
                        postTask();
                }).catch((error) => {
                    console.log('error', error);
                    checkAuth(error.response, this.props.history);
                });
            } else {
                this.setState({transactionData, userId: getUserId(), isLoading: false});
                if (postTask)
                    postTask();
            }
        }).catch((error) => {
            setTimeout(() => this.props.handleLoader(false), 200);
            console.log(error, 'error');
            checkAuth(error, this.props.history);
        });
    };

    updateUserCertificate(event) {
        this.setState({userCertificateIndex: event.target.value, userCompanyIndex: -1});
        console.log('userCertificateIndex: ' + event.target.value);
    }

    updateUserCompany(event) {
        this.setState({userCompanyIndex: event.target.value});
        console.log('userCompanyIndex: ' + event.target.value);
    }

    render() {
        const {userCertificates, verificationCode, userCertificateIndex, userCompanyIndex, transactionData, userId, isLoading} = this.state;

        return (!isLoading && !verificationCode ?
                <div className='content-wrapper'>
                    <div className="content m-b-16">
                        <div className="fields-row m-b-0">
                            <div className="back-arrow" onClick={() => this.props.history.goBack()}>←
                                Back
                            </div>
                            {/*<div className="content-h2">Transaction details</div>*/}
                            {/*{(transaction !== null && transaction.cryptoIdSignature.confirmTime !== null) &&*/}
                            <div className="download-block">
                                <div className='m-r-25'>
                                    <a target="_blank"
                                       href={`${process.env.API}/transaction/proof/pdf?transaction_id=${transactionData.id}`}>
                                        <DownloadCloudIcon/>
                                        Download PDF
                                    </a>
                                </div>
                                <div className='m-r-25'>
                                    <a target="_blank"
                                       href={`${process.env.API}/transaction/proof/json?transaction_id=${transactionData.id}`}>
                                        <DownloadCloudIcon/>
                                        Download JSON
                                    </a>
                                </div>
                                <div className='m-r-25'>
                                    <a target="_blank"
                                       href={`${process.env.API}/transaction/proof/asice?transaction_id=${transactionData.id}`}>
                                        <DownloadCloudIcon/>
                                        Download ASICE
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="hr-content"/>
                        <div className="transaction-hash-block">
                            <div className="row">
                                <div className="col-lg-6">
                                    <label className="field-hint-label">Transaction hash</label>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-8">
                                    <input className="payment-descr-input" type="text" aria-label="Search"
                                           disabled="true" value={transactionData.hash}/>
                                </div>
                            </div>
                        </div>

                        {transactionData.cryptoIdSignature && transactionData.cryptoIdSignature.confirmTime &&
                        <div className="signature-date-block">
                            <div className="row">
                                <div className="col-lg-4">
                                    <label className="small-info-label">Signature date:&nbsp;</label><label
                                    className="small-info-bold-label">{transactionData.cryptoIdSignature.confirmTime}</label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4">
                                    <label className="small-info-label">Transaction date:&nbsp;</label><label
                                    className="small-info-bold-label">{transactionData.txDate}</label>
                                </div>
                            </div>
                        </div>
                        }
                        <div className="sender-block">
                            <div className="content-h2">Sender</div>
                            {transactionData.senderCertificate && transactionData.senderCertificate.name ?
                                <div>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <label className="field-hint-label">Signature</label>
                                        </div>
                                        <div className="col-lg-6">
                                            <label className="field-hint-label">Company</label>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-4">
                                            <input className="payment-descr-input" type="text"
                                                   aria-label="Search"
                                                   disabled="true"
                                                   value={transactionData.senderCertificate.name}/>
                                        </div>
                                        <div className="col-lg-4 offset-lg-2">
                                            <input className="payment-descr-input" type="text"
                                                   aria-label="Search"
                                                   disabled="true"
                                                   value={transactionData.senderCompany.entity}/>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div>
                                    {transactionData.userStatus === 'Sender' ?
                                        <div className="fields-row">
                                            <SelectInput name='senderCertificate'
                                                         id='senderCertificate'
                                                         label='Signature'
                                                         required={true}
                                                         isValue={true}
                                                         value={userCertificateIndex}
                                                         classes='width-328'
                                                         displayedField={'name'}
                                                         options={userCertificates}
                                                         handleChange={(e) => this.updateUserCertificate(e)}/>
                                            <SelectInput name='senderCompany'
                                                         id='senderCompany'
                                                         label='Company'
                                                         required={true}
                                                         isValue={true}
                                                         value={userCompanyIndex}
                                                         classes='width-328'
                                                         displayedField={'entity'}
                                                         options={userCertificateIndex === -1 ? [] : userCertificates[userCertificateIndex].companies}
                                                         handleChange={(e) => this.updateUserCompany(e)}/>
                                        </div>
                                        :
                                        <div>
                                            <div className="row margin-top-10">
                                                <div className="col-lg-6">
                                                    <label className="field-hint-label">Sender email</label>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <input className="payment-descr-input" type="text"
                                                           aria-label="Search"
                                                           disabled="true" value={transactionData.senderEmail}/>
                                                </div>
                                            </div>

                                            <div className="row margin-top-10">
                                                <div className="col-lg-6">
                                                    <label className="field-hint-label">Sender company code</label>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <input className="payment-descr-input" type="text"
                                                           aria-label="Search"
                                                           disabled="true" value={transactionData.senderTaxNumber}/>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            <div className="row margin-top-10">
                                <div className="col-lg-6">
                                    <table className="table io-table">
                                        <thead>
                                        <tr>
                                            <th scope="col">Amount</th>
                                            <th scope="col">Wallet address</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {transactionData.senderData.map((senderData, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className={0 === index ? 'first-row' : ''}>
                                                        {Number((senderData.value / 100000000).toFixed(4))}
                                                    </td>
                                                    <td className={0 === index ? 'first-row' : ''}>
                                                        {senderData.address}
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="recipient-block">
                            <div className="content-h2">Recipient</div>
                            {transactionData.recipientCertificate && transactionData.recipientCertificate.name ?
                                <div>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <label className="field-hint-label">Signature</label>
                                        </div>
                                        <div className="col-lg-6">
                                            <label className="field-hint-label">Company</label>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-4">
                                            <input className="payment-descr-input" type="text"
                                                   aria-label="Search"
                                                   disabled="true"
                                                   value={transactionData.recipientCertificate.name}/>
                                        </div>
                                        <div className="col-lg-4 offset-lg-2">
                                            <input className="payment-descr-input" type="text"
                                                   aria-label="Search"
                                                   disabled="true"
                                                   value={transactionData.recipientCompany.entity}/>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div>
                                    {transactionData.userStatus === 'Recipient' ?
                                        <div className="fields-row">
                                            <SelectInput name='senderCertificate'
                                                         id='senderCertificate'
                                                         label='Signature'
                                                         required={true}
                                                         isValue={true}
                                                         value={userCertificateIndex}
                                                         classes='width-328'
                                                         displayedField={'name'}
                                                         options={userCertificates}
                                                         handleChange={(e) => this.updateUserCertificate(e)}/>
                                            <SelectInput name='senderCompany'
                                                         id='senderCompany'
                                                         label='Company'
                                                         required={true}
                                                         isValue={true}
                                                         value={userCompanyIndex}
                                                         classes='width-328'
                                                         displayedField={'entity'}
                                                         options={userCertificateIndex === -1 ? [] : userCertificates[userCertificateIndex].companies}
                                                         handleChange={(e) => this.updateUserCompany(e)}/>
                                        </div>
                                        :
                                        <div>
                                            <div className="row margin-top-10">
                                                <div className="col-lg-6">
                                                    <label className="field-hint-label">Recipient email</label>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <input className="payment-descr-input" type="text"
                                                           aria-label="Search"
                                                           disabled="true" value={transactionData.recipientEmail}/>
                                                </div>
                                            </div>

                                            <div className="row margin-top-10">
                                                <div className="col-lg-6">
                                                    <label className="field-hint-label">Recipient company code</label>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <input className="payment-descr-input" type="text"
                                                           aria-label="Search"
                                                           disabled="true" value={transactionData.recipientTaxNumber}/>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            <div className="row margin-top-10">
                                <div className="col-lg-6">
                                    <table className="table io-table">
                                        <thead>
                                        <tr>
                                            <th scope="col">Amount</th>
                                            <th scope="col">Wallet address</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {transactionData.recipientData.map((recipientData, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className={0 === index ? 'first-row' : ''}>
                                                        {Number((recipientData.value / 100000000).toFixed(4))}
                                                    </td>
                                                    <td className={0 === index ? 'first-row' : ''}>
                                                        {recipientData.address}
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-3">
                                <div className="amount-block">
                                    <label>Total amount: <i
                                        className="user-status">{Math.abs(Number((transactionData.totalAmount / 100000000).toFixed(4)))} {transactionData.currency}</i></label>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-3 tx-desc-label">
                                <label>Transaction description</label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-8">
                                <input className="form-control" type="text" aria-label="Search"
                                       className="payment-descr-input"
                                       disabled={true}
                                       value={transactionData.paymentDescription}/>
                            </div>
                        </div>
                        <div className="transaction-status-block">
                            <TransactionStatus onDigitalSign={() => {
                                this.registerTransaction()
                            }} transactionData={transactionData} userId={userId}/>
                        </div>
                    </div>
                </div> :
                <div className={'transaction-block'}>
                    {verificationCode ?
                        <div className={'center'}>
                            <div>
                                <p className={'verification-label'}>Verification code</p>
                                <p className={'verification-code'}>{verificationCode}</p>
                                <div className="loader"></div>
                            </div>
                        </div> : <div></div>
                    }
                </div>
        )
    }

    registerTransaction = () => {
        this.props.handleLoader(true);
        const reqBody = this.state.transactionData;
        reqBody.senderWallets = reqBody.senderData;
        reqBody.recipientWallets = reqBody.recipientData;
        reqBody.totalAmount = (reqBody.totalAmount < 0) ? reqBody.totalAmount * -1 : reqBody.totalAmount;
        reqBody.description = reqBody.paymentDescription;

        if (this.state.chooseSecondPart) {
            if (this.state.userCertificateIndex === -1 || this.state.userCompanyIndex === -1) {
                alert('Select certificate and company pleas');
                return;
            }
            const userCertificate = this.state.userCertificates[this.state.userCertificateIndex];
            const userCompany = userCertificate.companies[this.state.userCompanyIndex];
            console.log('User status: ' + this.state.transactionData.userStatus);
            if (this.state.transactionData.userStatus === 'Sender') {
                reqBody.senderCertificate = userCertificate;
                reqBody.senderCompany = userCompany;
            } else if (this.state.transactionData.userStatus === 'Recipient') {
                reqBody.recipientCertificate = userCertificate;
                reqBody.recipientCompany = userCompany;
            }
        }
        const authToken = getAuthToken();

        Api.post('transaction/register', reqBody, authToken).then((response) => {
            // const transactionData = this.state.transactionData;
            // transactionData.transactionId = response.data.transactionId;
            // this.setState({transactionData});
            console.log(response.data);
            this.onDigitalSign(response.data.transactionId);
        }).catch(error => {
            checkAuth(error, this.props.history);
            alert(error.response.data);
            console.log(error.response);
            setTimeout(() => this.props.handleLoader(false), 200)
        });
    };

    onDigitalSign = (txId) => {
        const {transactionData} = this.state;
        let companyId;
        if (transactionData.userStatus === 'Sender') {
            if (transactionData.senderCompany && transactionData.senderCompany.companyId) {
                companyId = transactionData.senderCompany.companyId;
            } else {
                const userCertificate = this.state.userCertificates[this.state.userCertificateIndex];
                const userCompany = userCertificate.companies[this.state.userCompanyIndex];
                companyId = userCompany.companyId;
            }
        } else if (transactionData.userStatus === 'Recipient') {
            if (transactionData.recipientCompany && transactionData.recipientCompany.companyId) {
                companyId = transactionData.recipientCompany.companyId;
            } else {
                const userCertificate = this.state.userCertificates[this.state.userCertificateIndex];
                const userCompany = userCertificate.companies[this.state.userCompanyIndex];
                companyId = userCompany.companyId;
            }
        }

        const authToken = getAuthToken();
        Api.post(`transaction/sign-with-asice?transaction_id=${txId}`, null, authToken).then(response => {
            localStorage.removeItem('select-company-transaction');
            this.setState({verificationCode: response.data});

            setTimeout(() => this.props.handleLoader(false), 200);
            this.interval2 = setInterval(() => {
                Api.get(`transaction?id=${txId}`, authToken).then((response) => {
                    const transactionData = response.data;
                    if (response.data.userStatus === 'Sender') {
                        if (transactionData.senderDigitalSignature.confirmTime) {
                            this.setState({verificationCode: null});
                            this.props.history.push(`/user/transaction/${txId}`);
                            clearInterval(this.interval2);
                            this.getTransaction();
                        }
                    } else {
                        if (transactionData.recipientDigitalSignature.confirmTime) {
                            this.setState({verificationCode: null});
                            this.props.history.push(`/user/transaction/${txId}`);
                            clearInterval(this.interval2);
                            this.getTransaction();
                        }
                    }
                });
            }, 1000);
        }).catch(error => {
            setTimeout(() => this.props.handleLoader(false), 200);
            console.log(error, 'error');
            console.log(error);
            checkAuth(error, this.props.history);
            this.props.handleLoader(false);
            alert(error.response.data);
        });


        // Api.get(`check`, false, true).then((response) => {
        //     console.log(response, 'response check applet');
        //     Api.get(`sign?transaction_id=${txId}&company_id=${companyId}`, false, true).then((response) => {
        //             console.log(response, 'response sign?transact_id');
        //
        //     }).catch((error) => {
        //         setTimeout(() => this.props.handleLoader(false), 200);
        //         console.log(error, 'error');
        //         console.log(error);
        //         checkAuth(error, this.props.history);
        //         this.props.handleLoader(false);
        //         alert(error.message);
        //     });
        // }).catch((error) => {
        //     setTimeout(() => this.props.handleLoader(false), 200);
        //     alert('Please launch and log in with Crypto ID application installed on your computer.');
        //     console.log(error, 'error check applet');
        // });
    };

    handleChange = event => {
        console.log(event.target.name, 'event.target.name', event.target.value);

        this.setState({
            [event.target.name]: event.target.value,
        });
    };
    // getCredentialSubject = () => {
    //     const authToken = getAuthToken();
    //     const transactionId = this.props.match.params.transactionId;
    //
    //     Api.get(`transaction/credential-subject?transaction_id=${transactionId}`, authToken).then((response) => {
    //
    //         console.log(response.data, 'get credential-subject');
    //
    //         if (response.data) this.setState({credentialSubject: JSON.stringify(response.data)});
    //
    //         setTimeout(() => this.props.handleLoader(false), 200)
    //     }).catch((error) => {
    //         setTimeout(() => this.props.handleLoader(false), 200);
    //         checkAuth(error, this.props.history);
    //         console.log(error, 'error')
    //     });
    // };
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(TransactionPage);



// WEBPACK FOOTER //
// ./src/views/TransactionPage/TransactionPage.js